import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "qty-picker mt-auto flex h-7 w-fit items-center border border-black-100 text-center text-lg font-medium" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "w-6 leading-6",
      onClick: _cache[0] || (_cache[0] = $event => ([_ctx.throttledQtyChange('minus', $props.product.key, $data.productQty), _ctx.$emit('isClicked')]))
    }, " - "),
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.productQty) = $event)),
      class: "w-7 text-center leading-6",
      onkeypress: "return event.charCode >= 48 && event.charCode <= 57",
      onInput: _cache[2] || (_cache[2] = $event => ([_ctx.debouncedInputChange($props.product.key, $data.productQty), _ctx.$emit('isClicked')]))
    }, null, 544), [
      [_vModelText, $data.productQty]
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "w-6 leading-6",
      onClick: _cache[3] || (_cache[3] = $event => ([_ctx.throttledQtyChange('plus', $props.product.key, $data.productQty), _ctx.$emit('isClicked')]))
    }, " + ")
  ]))
}